import PlanDetail from "./PlanDetail";

export default PlanDetail;
